import { useCallback } from "react";

const NODE_TYPES = [
  { type: "tool_call", label: "Tool Call", color: "#3b82f6", desc: "Execute a registered tool" },
  { type: "llm_call", label: "LLM Call", color: "#22c55e", desc: "Send prompt to an LLM" },
  { type: "conditional", label: "Condition", color: "#eab308", desc: "Branch on expression" },
  { type: "human_approval", label: "Approval", color: "#ec4899", desc: "Require human approval" },
  { type: "transform", label: "Transform", color: "#8b5cf6", desc: "Map/filter data" },
] as const;

export function NodePalette({
  onDragStart,
}: {
  onDragStart: (type: string, e: React.DragEvent) => void;
}) {
  return (
    <div className="flex w-48 shrink-0 flex-col border-r border-ink-100 bg-white">
      <div className="border-b border-ink-100 px-4 py-3">
        <h3 className="text-xs font-semibold uppercase tracking-wider text-ink-500">Nodes</h3>
      </div>
      <div className="flex-1 overflow-y-auto p-2 space-y-1.5">
        {NODE_TYPES.map((nt) => (
          <PaletteCard
            key={nt.type}
            type={nt.type}
            label={nt.label}
            color={nt.color}
            description={nt.desc}
            onDragStart={onDragStart}
          />
        ))}
      </div>
    </div>
  );
}

function PaletteCard({
  type,
  label,
  color,
  description,
  onDragStart,
}: {
  type: string;
  label: string;
  color: string;
  description: string;
  onDragStart: (type: string, e: React.DragEvent) => void;
}) {
  const handleDragStart = useCallback(
    (e: React.DragEvent) => {
      e.dataTransfer.setData("application/flax-node-type", type);
      e.dataTransfer.effectAllowed = "copy";
      onDragStart(type, e);
    },
    [type, onDragStart],
  );

  return (
    <div
      draggable
      onDragStart={handleDragStart}
      className="flex items-center gap-2.5 rounded-lg border border-ink-100 bg-white px-3 py-2.5 cursor-grab transition-shadow hover:shadow-sm active:cursor-grabbing"
    >
      <div
        className="h-3 w-3 shrink-0 rounded-sm"
        style={{ backgroundColor: color }}
      />
      <div className="min-w-0">
        <div className="text-xs font-medium text-ink-800">{label}</div>
        <div className="text-2xs text-ink-400 truncate">{description}</div>
      </div>
    </div>
  );
}
